import get from 'lodash/get';

import styles from './index.module.less';
import type { NetworkResourceKind, NetworkSelectOptionItem } from './types';

const RESOURCE_ANNOTATION_KEYS: Record<NetworkResourceKind, string> = {
  vpc: 'network.stack.io/vpc',
  securitygroup: 'network.stack.io/securitygroup',
};

const LABEL_NAME_MARGIN: Record<NetworkResourceKind, string> = {
  vpc: '10px',
  securitygroup: '1.5rem',
};

export function normalizeNetworkSelectValue(value: unknown): unknown {
  if (value === '' || value === null) return undefined;
  return value;
}

export function mapNetworkSelectOptions(items: unknown[], kind: NetworkResourceKind): NetworkSelectOptionItem[] {
  const annotationKey = RESOURCE_ANNOTATION_KEYS[kind];
  const nameMargin = LABEL_NAME_MARGIN[kind];

  return items.map((raw) => {
    const item = raw as Record<string, unknown>;
    const name = get(item, 'metadata.name', '-') as string;
    const annotations = get(item, 'metadata.annotations') as Record<string, string> | undefined;
    const displayName = get(item, 'spec.alias') || annotations?.[annotationKey] || name || '-';
    const desc = get(item, 'spec.description') || annotations?.['stack.io/description'];

    const label = (
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        <span style={{ display: 'inline-block', marginInlineEnd: nameMargin }}>{name}</span>
        <span className={styles.optionLabelExtra}>{String(displayName)}</span>
        <span className={styles.optionLabelExtra}>{desc ? String(desc) : '-'}</span>
      </div>
    );

    return {
      value: name,
      label,
      extra: JSON.stringify({ ...item, displayName }),
    };
  });
}

export function parseNetworkSelectDisplayName(option?: unknown): string | undefined {
  const extra = (option as { extra?: string } | undefined)?.extra;
  if (!extra) return undefined;
  try {
    const obj = JSON.parse(extra) as { displayName?: string };
    return obj.displayName;
  } catch {
    return undefined;
  }
}
